import {
  DefaultError,
  useMutation,
  UseMutationResult, useQueryClient,
} from '@tanstack/react-query';
import {AxiosHttpClient} from '../../../envisia/auth/axios-http-client';
import {environment} from '../../../../environments/environment';
import {articleStepsCopyListQueryKeys} from './article-steps-copy-list-query-keys';
import {ArticleProductionCopyForm, ArticleProductionStepCopyReplyElement} from './article-steps-copy.models';
import {Lister} from '../../../common/wrapper.models';

export function useArticleStepsCopyMutation():
  UseMutationResult<Lister<ArticleProductionStepCopyReplyElement>, DefaultError, ArticleProductionCopyForm> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (form) =>
      AxiosHttpClient.post<Lister<ArticleProductionStepCopyReplyElement>>(
        `${environment.apiv4uri}article/${form.targetOaNr}/production/copy`,
        form),
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: articleStepsCopyListQueryKeys.all});
    },
  });
}
